import { render, staticRenderFns } from "./F7appTim.vue?vue&type=template&id=066c5081&scoped=true&"
import script from "./F7appTim.vue?vue&type=script&lang=js&"
export * from "./F7appTim.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./F7appTim.vue?vue&type=style&index=0&id=066c5081&scoped=true&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "066c5081",
  "282e8024"
  
)

export default component.exports